import { initializeApp } from "firebase/app";
import "firebase/firestore";
var firebaseConfig = {
    apiKey: "AIzaSyBZtvoD9zdmFAz8Rk_DSm1a_RM15q3XNuM",
    authDomain: "brushfire-widget-source.firebaseapp.com",
    databaseURL: "https://brushfire-widget-source-default-rtdb.firebaseio.com",
    projectId: "brushfire-widget-source",
    storageBucket: "brushfire-widget-source.appspot.com",
    messagingSenderId: "75241792522",
    appId: "1:75241792522:web:f8255a1207d3949b452bf3",
    measurementId: "G-WMF6S4BXJP",
};
var firebaseStagingConfig = {
    apiKey: "AIzaSyBZtvoD9zdmFAz8Rk_DSm1a_RM15q3XNuM",
    authDomain: "brushfire-widget-source.firebaseapp.com",
    databaseURL: "https://entry-queue-staging.firebaseio.com",
    projectId: "brushfire-widget-source",
    storageBucket: "brushfire-widget-source.appspot.com",
    messagingSenderId: "75241792522",
    appId: "1:75241792522:web:f8255a1207d3949b452bf3",
    measurementId: "G-WMF6S4BXJP",
};
var firebasePubSubConfig = {
    apiKey: "AIzaSyC-eapf8bCHGgSWBpAS3Zg9B202snPrBtY",
    authDomain: "brushfire-pubsub-actions.firebaseapp.com",
    projectId: "brushfire-pubsub-actions",
    storageBucket: "brushfire-pubsub-actions.firebasestorage.app",
    messagingSenderId: "170170170510",
    appId: "1:170170170510:web:153d4989e854141959dddf"
};
var fb = initializeApp(process.env.REACT_APP_BF_ENV === "staging" || process.env.REACT_APP_BF_ENV === "future" ? firebaseStagingConfig : firebaseConfig);
var pubSubFb = initializeApp(firebasePubSubConfig, "brushfire-pubsub-actions");
export { pubSubFb };
export default fb;
